import { Component, Fragment } from "react";
import RichTextExpandableText from "components/rich-text-elements/rich-text-expandable-text/rich-text-expandable-text";
import { extract } from "@parksandresorts/core";

export default class RichTextFeature extends Component {
  constructor(props) {
    super(props);

    this.featureType = extract(props, "featureType");
    this.featureComponent = this.resolveFeatureType(this.featureType);
  }

  resolveFeatureType(featureType) {
    switch (featureType) {
      case "Expandable Text": {
        return RichTextExpandableText;
      }
      default: {
        return Fragment;
      }
    }
  }

  render() {
    return <this.featureComponent {...this.props} />;
  }
}
